import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    instanceName: {
        fontSize: '30px',
        color: '#272727',
        opacity: '1',
        marginTop: '5px',
        marginBottom: '5px',
        fontWeight: '600',
        fontFamily: 'Lato, sans-serif !important'
    },
    instanceStatus: {
        color: `${theme.palette.primary.dark} !important`,
        marginLeft: '10px',
        borderRadius: '3px !important',
        border: `1px solid ${theme.palette.primary.dark} !important`,
        backgroundColor: '#FFF !important'
    },
    instanceStatusChip: {
        color: `${theme.palette.primary.dark} !important`,
        transform: 'scale(0.6)'
    }
}));
